export default {
    unknown_subscriber_token: "Der Link ist leider ungültig 😥",
    unknown_subscriber_token_help: "Der Link führt zu einem Abonnement, das nicht gefunden werden kann. Bitte prüfen " +
        "Sie ob Sie den richtigen Link verwendet haben. Falls Sie der Meinung sind, dass dies ein Fehler ist, " +
        "kontaktieren Sie bitte den Herausgeber.",
    subscriptions_are_deactivated: "Dieses Newsletter ist zur Zeit nicht verfügbar 😥",
    subscriptions_are_deactivated_help: "Der Herausgeber hat dieses Newsletter deaktiviert. Dadurch sind aktuell keine" +
        " Anmeldungen zu diesem Newsletter und dessen Profilen möglich.",
    not_found: "Das Newsletter konnte leider nicht gefunden werden 😥",
    not_found_help: "Falls Sie meinen, dass dies ein Fehler ist, kontaktieren Sie bitte den Herausgeber.",
    server_error: "Das hätte nicht passieren dürfen!  😥",
    server_error_help: "Sie können gleich versuchen diese Anmeldung erneut aufzurufen. " +
        "Vielleicht war das eben nur ein kurzer Schluckauf unseres Systems. " +
        "Falls das Problem jedoch weiterhin besteht, dann machen Sie doch bitte den Herausgeber auf dieses Problem aufmerksam.",

    errorWhileDonation: "Leider ist bei Ihrer Spende ein Fehler aufgetreten. Bitte versuchen Sie es später erneut. " +
        "Falls dieser Fehler weiterhin besteht, melden Sie sich bitte beim Veranstalter.",

    paypalUnauthorized: "Es wurde die Zahlungsart 'PayPal' angegeben, jedoch konnte keine autorisierte PayPal Zahlung " +
        "zu Ihrer Spende gefunden werden.",

    invalidPaymentType: "Bei der Erstellung Ihrer Zahlung ist aufgrund ungültiger Daten ein Fehler aufgetreten.",
    paypalCaptureError: "Die PayPal Spendenzahlung konnte nicht eingezogen werden.",
    missingSepaMandate: "Zu der angegebenen Bankverbindung konnte kein SEPA Mandat gefunden werden.",
    missingPositions: 'Es konnte aufgrund fehlender Positionen keine Rechnung angelegt werden.',
    invalidIban: "Die angegebene IBAN ist ungültig.",
    noAnonymousContact: "Die Spende kann aufgrund fehlender Einstellungen des Projekts nicht gespeichert werden.",
    already_exists: "Die angegebene E-Mail Adresse ist bereits zu diesem Newsletter angemeldet.",
    orderTotalError: "Die angeforderten Zahlungswerte stimmen nicht mit den übermittelten überein.",
    paypalError: "Die verwendete Zahlungsschnittstelle konnte nicht erreicht werden.",
    orderCreationError: "Die angegebenen Daten wurden von der Zahlungsschnittstelle nicht akzeptiert.",
    orderTotalMismatch: "Der angefragte Zahlungsbetrag stimmt nicht mit dem errechneten überein.",
    articlePriceMismatch: "Angefragte Preise enthalten inkorrekte Werte."
}
